export default __webpack_public_path__ + "static/laptop-woman-a68945bdddb1bccf50db67f615dee5dd.jpg";